import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ITEM_GRID_COUNT } from '../config';
import { relationshipItemProp } from '../types';
import getRelationshipDisplayTypeComponent from '../utility/getRelationshipDisplayTypeComponent';
import isMappedTo from '../utility/isMappedTo';

import RelationshipDisplayItemSkeleton from './RelationshipDisplayItemSkeleton';

import './RelationshipDisplayGroups.scss';

const RelationshipDisplayGroups = ({ interfaceType, groups, activeShortSku }) => {

	const isOverflow = isMappedTo.group.interfaceType.which(interfaceType) === 'overflow';
	const skeletonContainerClass = classNames('RelationshipDisplayItemSkeletonContainer', {
		'RelationshipDisplayItemSkeletonContainer--overflow': isOverflow
	});

	const buildSkeleton = (skeletonCount, label) => {

		const count = skeletonCount >= 4 ? 4 : skeletonCount;
		const skeletons = Array.from(Array(count), (_, i) => <RelationshipDisplayItemSkeleton label={label} key={i} />);
		return skeletons;

	};

	const buildDisplayComponent = (groupLabel, relationshipItems, index) => {

		const RelationshipDisplayTypeComponent = getRelationshipDisplayTypeComponent(interfaceType, relationshipItems);

		return (
			<RelationshipDisplayTypeComponent
				label={groupLabel}
				activeShortSku={activeShortSku}
				relationshipItems={relationshipItems}
				interfaceType={interfaceType}
				index={index}
			/>
		);

	};
	return (
		<div className="RelationshipDisplayGroups" style={{ '--itemsGridCount': ITEM_GRID_COUNT }}>
			{groups.map((group, index) => (
				<div
					className="RelationshipDisplayGroups__container"
					key={group.label}
					data-capture-section={`ProductRelationships${group.label.replaceAll(' ', '')}`}
					data-has-add-to-cart="0"
				>
					<Suspense
						fallback={(
							<div className={skeletonContainerClass}>
								{buildSkeleton(group.relationshipItems.length, group.label)}
							</div>
						)}
					>
						{buildDisplayComponent(group.label, group.relationshipItems, index)}
					</Suspense>
				</div>
			))}
		</div>
	);

};

RelationshipDisplayGroups.propTypes = {
	interfaceType: PropTypes.number.isRequired,
	groups: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			relationshipId: PropTypes.number,
			relationshipItems: PropTypes.arrayOf(relationshipItemProp)
		})
	),
	activeShortSku: PropTypes.string
};

export default RelationshipDisplayGroups;
